<template>
    <main-content v-if="$can('read', 'settlement')">
        <div v-if="status=='success'">
            <manual-settlement v-if="form_data.type != 0" :form_data="form_data"/>
            <settlement-info v-else :form_data="form_data"/>
        </div>
    </main-content>
    <main-content v-else>
        <div v-if="status=='success'">
            <common-access-settlement-info :form_data="form_data"/>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import { mapGetters } from 'vuex'
    import settlementInfo from './component/settlement-info'
    import commonAccessSettlementInfo from './component/common-access-settlement-info'
    import manualSettlement from './component/manual-settlement'

    export default {
        components: {
            mainContent,
            settlementInfo,
            commonAccessSettlementInfo,
            manualSettlement,
        },
        computed: {
            ...mapGetters('settlement', [
                'form_data', 'status'
            ]),
        },
        data() {
            return {
                hashid: this.$route.params.hashid
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('settlement/find', vm.hashid)
            })
        },
    }
</script>

<style>
</style>